import React from "react";
import { useWeb3 } from "../context/Web3Context";
import { useToast } from "./common/Toast";
import { parseError } from "../utils/errors";
import { APP_NAME } from "../config/app.config";

export default function ConnectWallet() {
  const { connect, connecting, hasWallet } = useWeb3();
  const toast = useToast();

  const onConnect = async () => {
    if (!hasWallet) {
      toast.error("No wallet detected. Open in a wallet browser or install MetaMask.");
      return;
    }
    try {
      await connect();
      toast.success("Wallet connected.");
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <main className="app-content">
      <div className="hero hero-anim center fade-up" style={{ marginTop: 30 }}>
        <img src="/logo.png" alt={APP_NAME} className="connect-logo" />
        <h1 style={{ margin: "6px 0 4px" }}>{APP_NAME}</h1>
        <p className="muted" style={{ marginTop: 4 }}>
          Owner / Admin control panel for the Smartcore contracts.
        </p>
        <button className="btn btn-block mt-4" onClick={onConnect} disabled={connecting}>
          {connecting ? "Connecting…" : "Connect Wallet"}
        </button>
        <p className="muted mt-3" style={{ fontSize: 12 }}>
          Connect the owner or admin wallet. Actions from other wallets will be rejected on-chain.
        </p>
      </div>
    </main>
  );
}
